import React from 'react';
import { string, func, shape } from 'prop-types';
import { Small, Button } from 'components/common';
import classNames from 'classnames';
import './LoginSignUpTextLink.scss';

const LoginSignUpTextLink = ({ message, handlers, label }) => {
  const textLinkArr = (message.replace(label.CTA_LABLE, '|')).split('|');
  return (
    <div className={classNames('login-signup-text-link')}>
      <img
        alt=""
        src="https://images.contentstack.io/v3/assets/bltdf909986be592dae/bltc2bccfb849f22b8f/5ddf9eb4bfd937599939dbaa/icon-wave@3x.png"
        className="icon_wave"
      />
      <Small>
        {textLinkArr[0]}
        <Button as="button" text onClick={handlers.onCtaClick}>
          {label.CTA_LABLE}
        </Button>
        {textLinkArr[1]}
      </Small>
    </div>
  );
};

LoginSignUpTextLink.propTypes = {
  message: string,
  handlers: shape({
    onLoginCtaClick: func,
    onSignupCtaClick: func,
  }),
  label: shape({}),
};

LoginSignUpTextLink.defaultProps = {
  message: '',
  handlers: shape({
    onLoginCtaClick: null,
    onSignupCtaClick: null,
  }),
  label: null,
};

export default LoginSignUpTextLink;
